import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, TextDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UpdatePortalCustomMessageParams = {
  key: string;
  value: TextDto[];
};

export default function useUpdatePortalCustomMessage(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);

  const mutation = $api.useMutation("patch", "/shops/{shopId}/preferences/portals");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (requestBody: UpdatePortalCustomMessageParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
        body: {
          [requestBody.key]: requestBody.value,
        },
      });
    },
  });
}
